<div class="wrapper-list-stores">
  <!-- Page Header -->
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title" style="width: 100%">
            {{ "Stores" | translate }}
          </div>
          <!-- create store button here -->
          <div class="create-store topbar-actions">
            <div class="create-btn" [class.disabled]="!canCreateStore" (click)="showCreateStore()">
              <i class="fi fi-rr-plus"></i>
              {{ "Create Store" | translate }}
            </div>
          </div>
          <!-- create store button end here -->
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-4">
    <!-- Notifications & Limits Banners -->
    <div class="stores-banners mb-4">
      <!-- Status Notice -->
      <div class="stores-notice">
        <div class="alert alert-custom d-flex align-items-start" role="alert" [ngClass]="{'alert-primary-custom': !isConvertedSuspended, 'alert-warning-custom': isConvertedSuspended}">
          <div class="alert-icon mr-3">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
          </div>
          <div class="alert-message">
            {{
              !isConvertedSuspended
                ? ("Please note that toggling the maintenance mode on/off using the button might take up to 5 minutes to change and reflect." | translate)
                : isConverted
                ? ("Your account is currently under converted, and all stores functionality are unavailable. Please contact support for assistance." | translate)
                : ("Your account is currently under suspended, and all stores functionality are unavailable. Please contact support for assistance." | translate)
            }}
          </div>
        </div>
      </div>

      <!-- Limit / Plan Banners -->
      <div class="stores-limit">
        <!-- Upgrade Card -->
        <div class="w-100" *ngIf="!allowCreateStore">
          <button class="upgrade-plan-banner d-flex align-items-center w-100 h-100 text-left border-0" (click)="gotoStore(partnerPlatformUrl + '#/acl-subscription-payment')">
            <div class="upgrade-icon mr-3">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                <polyline points="2 17 12 22 22 17"></polyline>
                <polyline points="2 12 12 17 22 12"></polyline>
              </svg>
            </div>
            <div class="upgrade-text">
              <div class="upgrade-title">{{ "Upgrade Your Plan" | translate }}</div>
              <div class="upgrade-subtitle">{{ "Unlock multiple stores management" | translate }}</div>
            </div>
          </button>
        </div>

        <!-- Limit Progress Card -->
        <ng-container *ngIf="isAllowCreate">
          <!-- Limit Available -->
          <div class="limit-status-card w-100" *ngIf="!storeLimitReached">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="limit-label">{{ "Stores Limit Status" | translate }}</span>
              <span class="limit-value">{{ stores.length }} / {{ storeCountLimit }}</span>
            </div>
            <div class="progress-bar-container">
              <div class="progress-bar-fill" [style.width]="(stores.length / storeCountLimit * 100) + '%'"></div>
            </div>
            <div class="limit-desc mt-2">
              {{ "{0} available store left" | translate : [storeCountLimit - stores.length] }}
            </div>
          </div>
          <!-- Limit Reached -->
          <div class="limit-status-card limit-reached w-100" *ngIf="storeLimitReached">
            <div class="d-flex align-items-center">
              <div class="limit-icon mr-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
              </div>
              <div class="limit-text">
                <div class="limit-title">{{ "Limit Reached" | translate }}</div>
                <div class="limit-desc">{{ "You have reached the limit of {0} stores" | translate : [storeCountLimit] }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Empty State -->
    <div class="row justify-content-center py-5" *ngIf="stores.length == 0 && !loading">
      <div class="col-12 col-md-6 text-center empty-state-container">
        <div class="empty-icon mb-4">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
        <h4 class="empty-title">{{ "No Stores Found" | translate }}</h4>
        <p class="empty-desc">{{ "Get started by creating your first e-store." | translate }}</p>
        <button class="btn btn-primary-custom px-4 py-2 mt-2" [class.disabled]="!canCreateStore" (click)="showCreateStore()">
          {{ "Create Store" | translate }}
        </button>
      </div>
    </div>

    <!-- Stores Cards Grid -->
    <div class="stores-grid">
      <div class="stores-grid-item" *ngFor="let store of stores; let i = index" [formGroup]="itemForms[i]">
        
        <!-- Main Card View -->
        <div class="card store-card h-100 d-flex flex-column justify-content-between" *ngIf="store.mainCard" [class.disabled]="!store.status || isConvertedSuspended">
          <div class="card-header-section p-4 pb-0">
            <!-- Title & Status Badges -->
            <div class="store-title-row d-flex align-items-start justify-content-between mb-3">
              <div class="store-name-container">
                <h3 class="store-name m-0" title="{{ store.store_name }}">{{ store.store_name }}</h3>
              </div>
              <div class="badges-wrapper d-flex flex-wrap align-items-center justify-content-end">
                <span class="badge badge-warning-light m-0" *ngIf="store.maintenance !== '0'">
                  {{ "Maintenance" | translate }}
                </span>
                <span class="badge badge-success-light m-0" *ngIf="store.status && store.maintenance === '0'">
                  {{ "Active" | translate }}
                </span>
                <span class="badge badge-secondary-light m-0" *ngIf="!store.status">
                  {{ "Disabled" | translate }}
                </span>
                <span class="badge badge-primary-light m-0" *ngIf="+store.store_id === +defaultStore">
                  <svg class="mr-1" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                  {{ "Default" | translate }}
                </span>
              </div>
            </div>

            <!-- Store URL Bar -->
            <div class="store-url-box d-flex align-items-center justify-content-between px-3 py-2 rounded mb-3">
              <a class="url-link text-truncate mr-2" target="_blank" href="{{ store.store_url }}">{{ store.store_url }}</a>
              <div class="copy-action-btn">
                <i *ngIf="!copied && !isConvertedSuspended"
                  ngbTooltip="{{ 'Copy link' | translate }}"
                  [openDelay]="300"
                  [closeDelay]="500"
                  class="fi fi-rr-duplicate"
                  (click)="utils.copyToClipboard(store.store_url)"></i>
                <i *ngIf="copied && !isConvertedSuspended"
                  ngbTooltip="{{ 'Copied!' | translate }}"
                  tooltipClass="tooltipdisplay"
                  triggers="click"
                  [openDelay]="300"
                  [closeDelay]="500"
                  class="fi fi-rr-assept-document text-success"></i>
              </div>
            </div>

            <!-- Store Stats -->
            <div class="metrics-row d-flex border-top border-bottom py-3 mb-3">
              <div class="metric-item w-50 border-right text-center">
                <div class="metric-label">{{ "Total Sales" | translate }}</div>
                <div class="metric-value text-truncate">{{ store.currency }} {{ store.totalPrice }}</div>
              </div>
              <div class="metric-item w-50 text-center">
                <div class="metric-label">{{ "Products" | translate }}</div>
                <div class="metric-value">{{ products?.length || 0 }}</div>
              </div>
            </div>

            <!-- Toggles and Switches -->
            <div class="switches-section py-2">
              <!-- Default Switch -->
              <div class="toggle-control d-flex justify-content-between align-items-center mb-3">
                <div class="toggle-info text-left">
                  <div class="toggle-label">{{ "Set as Default" | translate }}</div>
                  <div class="toggle-desc">{{ "Make this your primary store" | translate }}</div>
                </div>
                <label class="switch-ios">
                  <input type="checkbox"
                    [disabled]="+store.store_id === +defaultStore || isConvertedSuspended"
                    [checked]="+store.store_id === +defaultStore"
                    (click)="toggleDefaultStore(store.store_id,+store.store_id === +defaultStore)" />
                  <span class="slider-ios"></span>
                </label>
              </div>

              <!-- Maintenance Mode -->
              <div class="toggle-control d-flex justify-content-between align-items-center">
                <div class="toggle-info text-left">
                  <div class="toggle-label">{{ "Maintenance Mode" | translate }}</div>
                  <div class="toggle-desc">{{ "Temporarily disable checkout" | translate }}</div>
                </div>
                <label class="switch-ios">
                  <input type="checkbox"
                    [disabled]="!store.status || isConvertedSuspended"
                    [checked]="store.maintenance !== '0'"
                    (click)="toggleStatus(store.store_id, store.maintenance)" />
                  <span class="slider-ios slider-success"></span>
                </label>
              </div>
            </div>
          </div>

          <!-- Card Actions -->
          <div class="card-footer-section p-4 border-top">
            <div class="mb-3 text-center">
              <button class="btn btn-link-details w-100 d-flex align-items-center justify-content-center" (click)="changeCard(i)" [class.disabled]="!store.status || isConvertedSuspended">
                <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="3"></circle>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                </svg>
                <span>{{ "Edit Store Settings" | translate }}</span>
              </button>
            </div>
            <div class="store-card-actions d-flex gap-2">
              <button class="btn btn-secondary-custom flex-grow-1" (click)="gotoStore(store.store_url)">
                {{ "View Store" | translate }}
              </button>
              <button class="btn btn-primary-custom flex-grow-1" (click)="modifyStore(store.store_id)">
                {{ "Modify Store" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- Details / Edit Form Card View -->
        <div class="card store-card details-view h-100 d-flex flex-column justify-content-between" *ngIf="store.detailsCard">
          <div class="p-4">
            <!-- Back Trigger -->
            <div class="d-flex align-items-center mb-3">
              <button class="btn btn-back-circle-small mr-2" (click)="cancelItem(i,cancelEdit, true)" [class.disabled]="loadingUpdate">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
              <h3 class="m-0">{{ "Store Details" | translate }}</h3>
            </div>
            
            <p class="section-hint mb-4">
              {{ "Update your store branding name and domain path mapping below." | translate }}
            </p>

            <!-- Store Name -->
            <div class="form-group-custom mb-3">
              <label class="form-label-custom">{{ "Store Name" | translate }}</label>
              <input
                type="text"
                formControlName="store_name"
                class="form-input-custom"
                [class.readonly]="!store.editButton"
                value="{{ store.store_name }}"
                (input)="validateStoreName(i)"
                [ngClass]="{'input-error': !store.validatingStoreName}"
              />
              <span class="error-text mt-1 d-block" *ngIf="store.nameRequired">
                {{ "Store Name is required." | translate }}
              </span>
              <p class="input-hint mt-2">
                {{ "The name of your store as you want it to appear in headers and invoices." | translate }}
              </p>
            </div>

            <!-- Subdomain -->
            <div class="form-group-custom mb-3">
              <label class="form-label-custom">{{ "Store location (URL)" | translate }}</label>
              
              <div class="input-group-custom" *ngIf="store.editButton">
                <input
                  type="text"
                  formControlName="subdomain"
                  class="form-input-custom text-lowercase"
                  placeholder="e-store-name"
                  maxlength="24"
                  oninput="this.value = this.value.toLowerCase()"
                  value="{{ store.subdomain }}"
                  (input)="validateDomain(i)"
                  [ngClass]="{'input-error': !store.validatingSubDomain}"
                />
                <span class="subdomain-prefix">.{{ storeSubdomain }}</span>
              </div>
              
              <span class="error-text mt-1 d-block" *ngIf="store.URLRequired">
                {{ "Store URL is required." | translate }}
              </span>
              <span class="error-text mt-1 d-block" *ngIf="store.unavailableSubdomain">
                {{ "Subdomain is not available." | translate }}
              </span>
              
              <div class="url-display px-3 py-2 rounded mt-2" *ngIf="!store.editButton">
                <a href="{{ store.store_url }}" target="_blank" class="url-link">{{ store.store_url }}</a>
              </div>
            </div>

          </div>

          <!-- Edit Actions Footer -->
          <div class="card-footer-section p-4 border-top">
            <div class="d-flex align-items-center justify-content-between">
              <!-- Remove Trigger -->
              <div>
                <button class="btn btn-remove-store d-flex align-items-center gap-1"
                  *ngIf="!store.editButton"
                  [class.hide-btn]="checkRemoveStatus(store.store_id)"
                  (click)="openModal(content, i)">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                  <span>{{ "Remove" | translate }}</span>
                </button>
              </div>

              <!-- Action buttons -->
              <div class="d-flex gap-2">
                <!-- Edit Action -->
                <button class="btn btn-primary-custom px-4" *ngIf="!store.editButton" (click)="editForm('edit', i)">
                  {{ "Edit" | translate }}
                </button>
                <!-- Cancel Action -->
                <button type="button" class="btn btn-secondary-custom px-3" *ngIf="store.editButton" (click)="editForm('cancel', i, cancelEdit)">
                  {{ "Cancel" | translate }}
                </button>
                <!-- Save Action -->
                <button type="button" class="btn btn-primary-custom px-4" *ngIf="store.editButton" (click)="saveItem(i)" [class.disabled]="saveButtonStatus(i)">
                  {{ "Save" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Remove store modal -->
  <ng-template #content let-modal>
    <div class="modal-content-custom">
      <div class="modal-body-custom p-4">
        <div class="modal-icon-danger mb-3">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <h4 class="modal-title-custom mb-2">{{ "Delete Store?" | translate }}</h4>
        <p class="modal-desc-custom m-0">
          {{ "Are you sure you want to delete this store? This action is permanent and cannot be undone." | translate }}
        </p>
      </div>
      <div class="modal-footer-custom p-3 border-top d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary-custom py-2 px-3" (click)="modal.close('cancel')">
          {{ "Cancel" | translate }}
        </button>
        <button type="button" class="btn btn-danger py-2 px-3" (click)="modal.close('delete')">
          {{ "Delete Store" | translate }}
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Cancel edit modal -->
  <ng-template #cancelEdit let-modal>
    <div class="modal-content-custom">
      <div class="modal-body-custom p-4">
        <div class="modal-icon-warning mb-3">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h4 class="modal-title-custom mb-2">{{ "Unsaved Changes" | translate }}</h4>
        <p class="modal-desc-custom m-0">
          {{ "You have unsaved store settings. Are you sure you want to leave without saving?" | translate }}
        </p>
      </div>
      <div class="modal-footer-custom p-3 border-top d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary-custom py-2 px-3" (click)="modal.close('cancel')">
          {{ "Cancel" | translate }}
        </button>
        <button type="button" class="btn btn-primary-custom py-2 px-3" (click)="modal.close('leave')">
          {{ "Discard & Leave" | translate }}
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Success modal -->
  <ng-template #success let-modal>
    <div class="modal-content-custom text-center">
      <div class="modal-body-custom p-4">
        <div class="modal-icon-success mb-3">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <h4 class="modal-title-custom mb-2">{{ "Successfully Updated" | translate }}</h4>
        <p class="modal-desc-custom m-0">
          {{ "Your e-store settings have been saved successfully." | translate }}
        </p>
      </div>
      <div class="modal-footer-custom p-3 border-top d-flex justify-content-center">
        <button class="btn btn-primary-custom py-2 px-4" type="button" (click)="modal.close('close')">
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
